import React from "react";
//import styled from "@emotion/styled";

function LanternLaunchPlaceholder() {
	return (
		<section className="container text-center">
			<div>
				<p>Temp placeholder to check QR codes work</p>
			</div>
		</section>
	);
}

export default LanternLaunchPlaceholder;
